export default "__VITE_ASSET__mtIHD4YC__"